import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Form, Field, Loader, Row, DatePicker, Button } from '@smartplatform/ui';

const WorkplanDay = ({ day }) => {
	const [times, setTimes] = useState();
	useEffect(() => {
		const getTimes = async () => {
			const times = await day.time();
			setTimes(times);
		};
		getTimes();
	}, []);

	if (!times) {
		return <Loader />;
	}

	const deleteTime = async time => {
		await day.time.destroyById(time.id);
		setTimes(await day.time());
	};

	const addEvent = async () => {
		await day.time.create({ time: moment(day.date).add(8, 'h') });
		setTimes(await day.time());
	};

	return (
		<>
			<h3>{moment(day.date).format('DD MMMM, dddd')}</h3>
			{times && times.totalCount === 0 && <h5>Нет событий на этот день</h5>}
			{times &&
				times.map((time, index) => {
					return (
						<Form
							key={`time-${time.id}`}
							record={time}
							stay
							beforeDelete={deleteTime}
							className={index === times.length - 1 ? 'workplan__time-last' : 'workplan__time'}
						>
							<Row>
								<Field property="time" label="Время события">
									<DatePicker showTimeSelect showTimeSelectOnly timeIntervals={15} />
								</Field>
								<Field property="place" label="Место" />
								<Field property="responsible" label="Ответственный" />
							</Row>
							<Row>
								<Field property="event" label="Событие">
									<textarea rows={4}></textarea>
								</Field>
							</Row>
						</Form>
					);
				})}
			<Button label="Добавить" onClick={addEvent} />
			<hr></hr>
		</>
	);
};

export default WorkplanDay;
